import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

function TopViewCar({
  color = 'icon.primary',
  fill = 'transparent',
  ...props
}) {
  return (
    <IconBase viewBox='0 0 14 19' {...props}>
      <Path
        d='M11.4249 11.0633L12.7734 11.0702'
        stroke={color}
        fill={fill}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M4.67969 11.0633L3.33111 11.0702'
        stroke={color}
        fill={fill}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M4.67897 11.0391L5.47665 9.85259C5.85425 9.29061 6.47595
        8.95509 7.13945 8.95509L8.96139 8.95509C9.62489 8.95509 10.2466
        9.29061 10.6242 9.85259L11.4219 11.0391'
        stroke={color}
        fill={fill}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M6.70184 4.80153L9.399
        4.80153C10.5163 4.80153 11.4219 5.84421 11.4219 7.13067L11.4219
        16.4472C11.4219 17.3051 10.8184 18 10.0733 18L6.02755 18C5.28246
        18 4.67896 17.3051 4.67896 16.4472L4.67897 7.13067C4.67897 5.84421
         5.58454 4.80153 6.70184 4.80153Z'
        stroke={color}
        fill={fill}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M4.67897 15.2152L11.4219 15.2152'
        stroke={color}
        fill={fill}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M0.578125 1.4375L3.71334 4.17589'
        stroke={color}
        fill={fill}
        strokeLinecap='round'
      />
      <Path
        d='M1.42188 4.16723H3.71456V1.69531'
        stroke={color}
        fill={fill}
        strokeLinecap='round'
      />
    </IconBase>
  )
}

TopViewCar.propTypes = {
  color: PropTypes.string,
  fill: PropTypes.string,
}

export default TopViewCar
